{
  "manager": {
    "formEditor": {
      "sharePublicLink": "Share Public Link",
      "downloadPdf": "Download PDF",
      "emailPdfToUser": "Email PDF to User",
      "confirmClear": "Confirm Clear",
      "clear": "Clear"
    },
    "formsCreate": {
      "note": "Note:",
      "readOnlyNote": "This form was created by a parent tenant and cannot be edited.",
      "childTenantNote": "All forms created here will be present on child tenants as well. The form will be locked and cannot be edited or deleted from child tenants.",
      "startingPointLabel": "Starting point",
      "startingPointDescription": "Start from a blank form or use a standard template.",
      "loadingTemplate": "Loading template…",
      "rentalTemplateLabel": "Rental agreement template:",
      "rentalTemplateDescription": "The standard rental agreement fields and terms are loaded in the editor below. Select an associated facility, then save the form.",
      "titleLabel": "Title *",
      "titleInvalidFeedback": "Please enter a title for your form.",
      "titlePlaceholder": "Enter a title for your form",
      "typeLabel": "Type *",
      "typeInvalidFeedback": "Please select a form type.",
      "facilityLabel": "Associated Facility *",
      "facilityInvalidFeedback": "Please select a facility.",
      "descriptionLabel": "Description",
      "descriptionHelp": "If this is a public form, users will see this description when filling out the form.",
      "submissionSettingsLabel": "Submission Settings",
      "allowRepeatSubmissions": "Allow users to submit updated registration responses after they have already registered",
      "saveForm": "Save Form",
      "associatedUserFields": "Associated User Fields",
      "userFieldsIntro": "You have denoted that this form is to be shown during the registration process for a user. If you'd like, you can create associations between your custom form fields and custom profile fields.",
      "clearAssociations": "Clear Associations",
      "configureForm": "Configure Form",
      "saveAssociations": "Save Associations"
    },
    "formsIndex": {
      "title": "Forms",
      "notApplicable": "N/A"
    }
  },
  "guest": {
    "formShow": {
      "errorLabel": "Error:",
      "formResponsesLocked": "Form Responses Locked",
      "responsesLockedMessage": "Form responses have been locked for this {bookingType} and can no longer be submitted or modified.",
      "submissionRecorded": "Your form submission has been recorded. Thank you!",
      "aFormBy": "A form by"
    }
  }
}
